const DATE_ONLY_REPORT_DATE_PATTERN = /^(\d{4})-(\d{2})-(\d{2})$/;

export const getReportDateTimestamp = (reportDate: string): number | null => {
  const dateParts = DATE_ONLY_REPORT_DATE_PATTERN.exec(reportDate);

  if (!dateParts) {
    return null;
  }

  const [, yearPart, monthPart, dayPart] = dateParts;
  const year = Number(yearPart);
  const month = Number(monthPart);
  const day = Number(dayPart);
  const timestamp = Date.UTC(year, month - 1, day);
  const date = new Date(timestamp);

  if (
    date.getUTCFullYear() !== year ||
    date.getUTCMonth() !== month - 1 ||
    date.getUTCDate() !== day
  ) {
    return null;
  }

  return timestamp;
};

export const sortByReportDate = <T>(
  rows: readonly T[],
  getReportDate: (row: T) => string,
): T[] =>
  rows
    .map((row, index) => ({
      row,
      index,
      timestamp: getReportDateTimestamp(getReportDate(row)),
    }))
    .sort((a, b) => {
      if (a.timestamp !== null && b.timestamp !== null) {
        return a.timestamp - b.timestamp || a.index - b.index;
      }
      if (a.timestamp !== null) {
        return -1;
      }
      if (b.timestamp !== null) {
        return 1;
      }
      return a.index - b.index;
    })
    .map(({ row }) => row);

export const formatReportDateLabel = (reportDate: string): string => {
  const timestamp = getReportDateTimestamp(reportDate);

  if (timestamp === null) {
    return reportDate;
  }

  const date = new Date(timestamp);
  return date.toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
    timeZone: "UTC",
  });
};
